import useEvidenceDisplayName from '../../../shared/hooks/useDisplayNames/variants/useEvidenceDisplayName'
import useStrategicImperativeDisplayName from '../../../shared/hooks/useDisplayNames/variants/useStrategicImperativeDisplayName'
import useTppDisplayName from '../../../shared/hooks/useDisplayNames/variants/useTppDisplayName'
import useValueMessageDisplayName from '../../../shared/hooks/useDisplayNames/variants/useValueMessageDisplayName'
import { ActivityDisplayNames } from './ActivityTable.types'

export const useActivityDisplayNames = (): ActivityDisplayNames => ({
    valueMessages: useValueMessageDisplayName().plural,
    strategicImperatives: useStrategicImperativeDisplayName().plural,
    tpp: useTppDisplayName().singular,
    evidence: useEvidenceDisplayName().plural,
})
